module.exports = __webpack_public_path__ + "img/banner-industry-innovation-infrastructure.7e87d0a2.png";